

const createHoursMins = (req: any) => {




    const [timePart, ampm] = req.time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (ampm === 'PM' && hours !== 12) {
        hours += 12;
    }
    if (ampm === 'AM' && hours === 12) {
        hours = 0;
    }
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    console.log(formattedTime);
    req.time = formattedTime;


    return formattedTime;
}

const utcObj = (req: any) => {
    let utcDate = null;
    let time = createHoursMins(req);
    if (req.date) {
        const [day, month, year] = req.date.split('-').map(Number);
        const [hours, minutes] = time.split(':').map(Number);
        const localDate = new Date(year, month - 1, day, hours, minutes);
        utcDate = new Date(localDate.getUTCFullYear(),
            localDate.getUTCMonth(),
            localDate.getUTCDate(),
            localDate.getUTCHours(),
            localDate.getUTCMinutes(),
            localDate.getUTCSeconds()
        );

    } else {
        const now = new Date();
        const [hours, minutes] = time.split(':').map(Number);
        const localDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
        utcDate = new Date(localDate.getUTCFullYear(),
            localDate.getUTCMonth(),
            localDate.getUTCDate(),
            localDate.getUTCHours(),
            localDate.getUTCMinutes(),
            localDate.getUTCSeconds()
        );

    }
    const utcDay = String(utcDate.getDate()).padStart(2, '0');
    const utcMonth = String(utcDate.getMonth() + 1).padStart(2, '0');
    const utcYear = utcDate.getFullYear();
    const formattedDate = `${utcDay}-${utcMonth}-${utcYear}`;

    // Format time as "HH:MM"
    const utcHours = String(utcDate.getHours()).padStart(2, '0');
    const utcMinutes = String(utcDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${utcHours}:${utcMinutes}`;
    req.time = formattedTime;
    req.date = formattedDate;
    return req;

}

const utcDate = (req: any) => {
    const [day, month, year] = req.date.split('-').map(Number);
    const [hours, minutes] = req.time.split(':').map(Number);
    const localDate = new Date(year, month - 1, day, hours, minutes);
    const utcDate = new Date(localDate.getUTCFullYear(),
        localDate.getUTCMonth(),
        localDate.getUTCDate(),
        localDate.getUTCHours(),
        localDate.getUTCMinutes(),
        localDate.getUTCSeconds()
    );
    return utcDate;
}


const formatTime = (date: Date): string => {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error("Invalid date provided");
        return "Invalid date";
    }

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
};



const useUTCDate = () => {
    return {
        utcDate,
        createHoursMins,
        formatTime,
        utcObj

    };
};

export default useUTCDate;